import { render, staticRenderFns } from "./CarModelInfo.vue?vue&type=template&id=23e16726&scoped=true"
import script from "./CarModelInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CarModelInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CarModelInfo.vue?vue&type=style&index=0&id=23e16726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e16726",
  null
  
)

export default component.exports